import { ObservableArray, View } from "binder"
import { PersonnelTask, PersonnelTaskManipulationViewModel } from "./personnelTaskManipulation-viewModel"

export class PersonnelTaskManipulationView extends View<PersonnelTaskManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-61FC29C2-B7F9-400F-BDA4-A02542D7AA47"
    }
    loadHtml(): string {
        let element = require('./personnelTaskManipulation.html').default;
        let style = require('./personnelTaskManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personnelTasks(v: ObservableArray<PersonnelTask>) { this._personnelTasks = v; } public get personnelTasks(): ObservableArray<PersonnelTask> { return this._personnelTasks;} private _personnelTasks: ObservableArray<PersonnelTask>;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;

    refresh():void{
        this.dataContext.refresh();
    }

    createNewTask():void{
        this.dataContext.createPersonnelTask();
    }
    
}
